export default __webpack_public_path__ + "static/remeltedwax-7f504de704726c0ea14b7892efa3a3e1.png";